<template>
  <div class="interview-list-item" @click="handleClick">
    <div class="d-flex justify-space-between align-center">
      <div class="d-flex flex-grow-1 flex-wrap">
        <div class="interview-item-details">
          <v-icon class="interview-icon" large>
            mdi-clipboard-text-outline
          </v-icon>
          <Permissioned section="interviews.view" vertical>
            <h3
              permission="name"
              class="ml-2 mb-1"
              role="heading"
              aria-level="2"
            >
              {{ title }}
            </h3>
            <span
              class="secondary-text ml-2"
              permission="datetime"
              :class="{ strikethrough: interview.cancelled }"
            >
              {{ interviewDateTimeRange }}
            </span>
          </Permissioned>
          <Chip
            color="red"
            class="full-width font-weight-bold"
            shrink
            v-if="interview.cancelled"
          >
            CANCELLED
          </Chip>
        </div>
      </div>
    </div>
    <Permissioned section="interviews.view" vertical>
      <InterviewParticipants
        permission="candidate"
        :participants="interviewers"
        participantsType="interviewers"
      />
      <InterviewParticipants
        permission="interviewers"
        :participants="candidates"
        participantsType="candidates"
      />
    </Permissioned>
  </div>
</template>

<script>
import {
  getInterviewParticipants,
  getInterviewDateTimeRange
} from "@/views/bookings/BookingInterviews/modules/utils";
import InterviewParticipants from "@/views/bookings/BookingInterviews/components/InterviewParticipants";
import Permissioned from "@/components/common/Permissioned";
import Chip from "@/components/common/Chip";

export default {
  components: {
    InterviewParticipants,
    Permissioned,
    Chip
  },
  props: {
    interview: {
      type: Object,
      required: true
    },
    showJobTitile: Boolean,
    shouldRedirectToGlobalDetails: Boolean
  },
  computed: {
    title() {
      const { interviewName, booking } = this.interview.interviewFormat;
      const bookingTitle = this.showJobTitile ? `(${booking.title})` : "";
      return `
      ${interviewName} ${bookingTitle}
      `;
    },
    interviewers() {
      return getInterviewParticipants(this.interview, "interviewer");
    },
    candidates() {
      return getInterviewParticipants(this.interview, "candidate");
    },
    interviewDateTimeRange() {
      return getInterviewDateTimeRange(this.interview);
    }
  },
  methods: {
    handleClick() {
      const interviewDetailsPath = `${
        this.shouldRedirectToGlobalDetails ? "/" : ""
      }interviews/${this.interview.id}`;
      this.$router.push(interviewDetailsPath);
    }
  }
};
</script>

<style lang="scss">
.interview-list-item {
  cursor: pointer;
  padding-bottom: 25px;
  padding: 15px;

  &:hover {
    background-color: $background !important;
  }

  .interview-item-details {
    display: flex;
    align-items: center;
    flex-grow: 1;

    @media only screen and (max-width: $mobile-breakpoint - 1) {
      @include column-icon-item;
    }
  }
}
</style>
